<template>
    <div>
        <appPage :isDefaultBackground="!!(preData?.background)"
            :backImg="preData?.background || info?.background || defaultBackground"
            @click="handleCloseOpeningRemarksPopup()">
            <!-- @touchmove="handleTouchMove" @touchend="handleTouchEnd" @touchstart="handleTouchStart" -->
            <div :class="{ 'message-clearing': isClearing, 'message-restoring': isRestoring }" v-if="!isCleared">
                <!-- 聊天头部 -->
                <ChatHeader :avatar="preData?.avatar || info?.avatar" :name="preData?.name || info?.name"
                    :expenses="expenses" :isFavorite="info?.isFavorite" :isKeyboardShow="isKeyboardShow"
                    @back="handleBack" @gotoDetail="handleGotoDetail" @like="handleLike" @showDrawer="handleShowDrawer"
                    :isShowFree="isShowFree" :id="info?.id" />
                <!-- </div> -->
                <!-- 渐变遮罩 -->
                <div class="w-100% absolute top-0 right-0 h-140px mask-transparent-top"></div>
                <!-- 渐变遮罩 -->
                <div class="w-100% fixed z-0 bottom-0 right-0 h-140px mask-transparent-bottom"
                    :class="{ 'backdrop-ready': isBackdropReady }"></div>
                <!-- 透明遮罩 -->
                <div class="w-100% absolute top-0 right-0 h-140px transparent-mask-top"></div>
                <!-- 透明遮罩 -->
                <!-- 聊天内容 -->
                <ChatRecord ref="chatRecordRef" :showConfirmNamePopup="showConfirmNamePopup"
                    :isKeyboardShow="isKeyboardShow" :digitalHumanId="preData?.id || info?.id"
                    :digitalHumanName="preData?.name || info?.name" :info="info"
                    :digitalHumanAvatar="preData?.avatar || info?.avatar" :getRecordId="getRecordId"
                    @messageSent="handleMessageSent" @keyboardShow="handleKeyboardShow"
                    @keyboardHide="handleKeyboardHide" :isClearing="isClearing" :isRestoring="isRestoring"
                    :sceneList="sceneList" :getSceneList="getSceneList" :chatHeight="chatHeight"
                    :handleIsAllTranslate="handleIsAllTranslate" :isAllTranslate="isAllTranslate"
                    :handleShowOpeningRemarksPopup="handleShowOpeningRemarksPopup"
                    :handleShowReloadMessagePopup="handleShowReloadMessagePopup"
                    :isRecommendedReply="isRecommendedReply" :isShowFree="isShowFree" />
            </div>

            <!-- 底部输入框 -->
            <ChatInputBox :isBackdropReady="isBackdropReady" :disabled="isReplying"
                :distanceToViewportBottom="distanceToViewportBottom" :showChangeSceneTip="showChangeSceneTip"
                :isEmbeddedH5="isEmbeddedH5" @send="handleSendMessage" @switchScene="showSwitchModelPopup = true"
                @keyboardShow="handleKeyboardShow" :sceneList="sceneList" @keyboardHide="handleKeyboardHide"
                @updateDistance="distanceToViewportBottom = $event" :info="info" :isShowFree="isShowFree"
                @handleQuickReply="showQuickReplyPopup = true" />

            <!-- 占位空间，避免内容被固定输入框遮挡 -->
            <AppOccupySpace height="100px"></AppOccupySpace>
        </appPage>
        <!-- 余额不足 -->
        <ChatRecommendedPurchases v-if="showRecommendedPurchases" />
        <!-- 举报弹窗 -->
        <van-popup v-model:show="showPopup" position="bottom" round class="p-20px">
            <Report :recordId=recordId :reportType="reportStore.reportTypeList" :close="handleClosePopup"
                :info="info" />
        </van-popup>

        <!-- 评分弹窗 -->
        <!-- <RatingPopup v-model:show="showRatingPopup" @rate="handleRating" @cancel="handleCancelRating" /> -->

        <!-- 右侧抽屉 -->
        <van-popup v-model:show="showDrawer" position="right"
            :style="{ width: '80%', height: '100%', background: '#01031B', borderRadius: '0px', }" teleport="body"
            :overlay="true" :close-on-click-overlay="true" class="drawer-popup">
            <SettingsRight :checkBg="handleCheckBg" :handleReport="handleReport" :handleDelete="handleDelete"
                :handleIsAllTranslate="handleIsAllTranslate" :isAllTranslate="isAllTranslate"
                :handleShowStorePopup="handleShowStorePopup" :hanldeClose="hanldeClose"
                :handleThinkingToast="handleThinkingToast" :info="info"
                :showModel="() => { showModelPopup = true, showDrawer = false }"
                :showChatStyle="() => { showChatStylePopup = true, showDrawer = false }"
                :showChatPerspective="() => { showChatPerspectivePopup = true, showDrawer = false }"
                :isShowFree="isShowFree" :modelList="modelList" />
        </van-popup>
        <!-- 切换背景 -->
        <van-popup v-model:show="showBgPopup" position="bottom" round class="p-20px bg-#01031B!">
            <checkBg ref="checkBgRef" :id="info.id" :checkSetBg="handleSetCheckBg" :background="info.background"
                :info="info" />
        </van-popup>
        <!-- 切换模型 -->
        <van-popup v-model:show="showModelPopup" position="bottom" round class="p-20px bg-#01031B!">
            <chatModel ref="checkBgRef" :id="info.id" :close="() => { showModelPopup = false }" :info="info"
                :modelList="modelList" :getModelList="getModelList" />
        </van-popup>
        <!-- 聊天风格 -->
        <van-popup v-model:show="showChatStylePopup" position="bottom" round class="p-20px bg-#01031B!">
            <chatStyle ref="checkBgRef" :id="info.id" :close="() => { showChatStylePopup = false }" :info="info"
                :modelList="modelList" />
        </van-popup>
        <!-- 聊天视角 -->
        <van-popup v-model:show="showChatPerspectivePopup" position="bottom" round class="p-20px bg-#01031B!">
            <chatPerspective ref="checkBgRef" :id="info.id" :close="() => { showChatPerspectivePopup = false }"
                :info="info" :modelList="modelList" />
        </van-popup>
        <!-- 商店弹窗 -->
        <van-popup v-model:show="showStorePopup" position="bottom" round>
            <StoreCom :handleClose="handleClosePopup" :isShowStayPopup="false" />
        </van-popup>
        <!-- 提示弹窗 -->
        <ThinkingToast v-model:show="showThinkingToastPopup" :duration="2000" />
        <!-- 首次进入聊天页面 -->
        <FirstConfirmNamePopup v-model:show="showConfirmNamePopup" :avatar="info?.avatar"
            @confirm="handleConfirmName" />
        <!-- 场景切换弹窗 -->
        <ChatSceneSelector v-model:show="showSwitchModelPopup" :sceneList="sceneList" @select="handleSwitchScene" />
        <!-- 翻译锁定提示弹窗 -->
        <ChatTosatCenter v-model:show="showToastPopup" :isAllTranslate="isAllTranslate"
            :message="!isAllTranslate ? t('toast.translationUnlocked') : t('toast.translationLocked')" />
        <!-- 开场白弹窗 -->
        <ChatOpeningRemarksPopup v-model:visible="showOpeningRemarksPopup" :recommendedReply="recommendedReply"
            @handleSendMessage="handleSendMessage" />
        <!-- 快捷回复弹窗 -->
        <van-popup v-model:show="showQuickReplyPopup" position="bottom" round class="p-20px bg-#01031B!">
            <ChatQuickReplyPopup :quickReplyList="quickReplyList" @handleQuickReplyMessage="handleQuickReplyMessage" />
        </van-popup>

    </div>
</template>
<script setup lang="ts">

import { detailDB } from '@/utils/detailDB'
import checkBg from './Component/ChatCheckBg.vue'
import ChatModel from './Component/chatModel.vue'
import SettingsRight from './Component/ChatSettingsRight.vue'
import FirstConfirmNamePopup from './Component/ChatFirstConfirmNamePopup.vue'
import ThinkingToast from './Component/ChatThinkingToast.vue'
import ChatHeader from './Component/ChatHeader.vue'
import ChatInputBox from './Component/ChatInputBox.vue'
import ChatSceneSelector from './Component/ChatSceneSelector.vue'
import { AppPage, AppOccupySpace } from '@/components/layout'
import { useRatingPopup } from '@/composables/useRatingPopup'
import { useRouter, useRoute } from 'vue-router'
import { onMounted, onUnmounted, ref, computed, nextTick, watch } from 'vue'
import ChatTosatCenter from './Component/ChatTosatCenter.vue'
import { roleProfileDB } from '@/utils/roleProfileDB'
import { MessageAPI } from '@/services/message'
import Report from './Component/ChatReport.vue'
import ChatRecord from './Component/ChatRecord.vue'
import { useChatStore } from '@/stores/chat'
import { useUserStore } from '@/stores/user'
import { showSuccessToast, showErrorToast, showWarningToast, showLoadingToast, closeToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'
import StoreCom from './Component/StoreCom.vue'
import { useBackgroundStore } from '@/stores/background'
import { useWaterfallStore } from '@/stores/waterfall'
import { useReportStore } from '@/stores/report'
import { logEventSafe } from '@/plugins/firebase'
import ChatRecommendedPurchases from './Component/ChatRecommendedPurchases.vue'
import ChatOpeningRemarksPopup from './Component/ChatOpeningRemarksPopup.vue'
import ChatQuickReplyPopup from './Component/ChatQuickReply.vue'
import chatStyle from './Component/chatStyle.vue'
import chatPerspective from './Component/chatPerspective.vue'
import { getSceneCache, saveSceneCache, deleteSceneCache } from '@/utils/sceneCacheDB'
import { recommendedReplyList } from '@/utils/recommendedReply';
import { useDialog } from '@/composables/useDialog'
import { useThrottleFn } from '@vueuse/core'
const dialog = useDialog()
const router = useRouter()
const waterfallStore = useWaterfallStore()
const showBgPopup = ref(false)
const showPopup = ref(false)
const showStorePopup = ref(false)
// 快捷回复弹窗显示状态
const showQuickReplyPopup = ref(false)
// 聊天风格弹窗显示状态
const showChatStylePopup = ref(false)
// 聊天视角弹窗显示状态
const showChatPerspectivePopup = ref(false)
// 右侧抽屉显示状态
const showDrawer = ref(false)
// 举报弹窗显示状态
const recordId = ref('')
const isAllTranslate = ref(false)
const chatStore = useChatStore()
const expenses = computed(() => userStore.getChatExpenses())
const isShowFree = computed(() => userStore.getIsFree().includes(info.value?.pid))
const backgroundStore = useBackgroundStore()
const userStore = useUserStore()
const reportStore = useReportStore()
const isKeyboardShow = ref(false)
const showThinkingToastPopup = ref(false)
const preData = ref()
const route = useRoute()
// 模型弹窗显示状态
const showModelPopup = ref(false)
// 滑动清屏功能
const touchStartX = ref(0)
const touchStartY = ref(0)
const touchStartTime = ref(0)
const isSwipeActive = ref(false)
const isClearing = ref(false) // 清屏动画状态
const isRestoring = ref(false) // 还原动画状态
const clearedMessages = ref<any[]>([]) // 保存清屏前的消息
const isCleared = ref(false) // 标记是否已清屏
const showConfirmNamePopup = ref(false)
const defaultBackground = ref<string>('')
const showToastPopup = ref(false)
const modelList = ref<any[]>([])
const quickReplyList = ref<any[]>([])
// 开场白弹窗显示状态
const showOpeningRemarksPopup = ref(false)
// 异步加载默认背景图
const loadDefaultBackground = async (type: number) => {
    try {
        if (type === 1) {
            const module = await import('@/assets/images/message/back_ground_female.webp')
            defaultBackground.value = module.default
        } else if (type === 2) {
            const module = await import('@/assets/images/message/back_ground_male.webp')
            defaultBackground.value = module.default
        } else {
            const module = await import('@/assets/images/message/back_ground_female.webp')
            defaultBackground.value = module.default
        }
    } catch (error) {
        console.error('加载默认背景图失败:', error)
    }
}
const { t } = useI18n()

// 评分弹窗
const { incrementMessageCount, getMessageCount } = useRatingPopup()

// 输入框相关状态
const distanceToViewportBottom = ref(0)
const chatHeight = ref()
const showChangeSceneTip = ref(false)
const showSwitchModelPopup = ref(false)
const isEmbeddedH5 = computed(() => userStore.isEmbeddedH5)
const currentMessages = computed(() => chatStore.currentMessages);
const isBackdropReady = ref(false)
/**
 * 显示推荐购买弹窗
 */
const showRecommendedPurchases = computed(() => {
    const expensesValue = expenses.value
    if (expensesValue === 0 || expensesValue === null || expensesValue === undefined) {
        return false
    }
    if (userStore.getMsgCost() / expensesValue <= 1) {
        localStorage.setItem('$9.99_popup_show', 'true')
        logEventSafe('$9.99_popup_show')
    }
    return userStore.getMsgCost() / expensesValue <= 1
})

const isRecommendedReply = ref<boolean>(false)
const recommendedReply = computed(() => {
    const recommendedObject = recommendedReplyList.find(item => item.roleId === info.value?.id)
    if (recommendedObject) {
        isRecommendedReply.value = true
        return recommendedObject.list
    }
    return []
});

// 🔧 动态计算消息列表高度
const calculateChatHeight = () => {
    // 获取视口高度
    const viewportHeight = window.innerHeight

    // 头部高度（ChatHeader 约 60px）
    const headerHeight = 60

    // 底部输入框高度（基础高度 + padding，约 80-100px）
    // 注意：输入框可能会因为内容而变高，这里取基础高度
    const footerHeight = 100

    // 计算剩余高度
    const remainingHeight = viewportHeight - headerHeight - footerHeight

    // 更新高度
    chatHeight.value = remainingHeight - 20

    // console.log(`📐 计算聊天高度: 视口=${viewportHeight}px, 头部=${headerHeight}px, 底部=${footerHeight}px, 聊天区=${remainingHeight}px`)
}

// 将解析后的对象转换为响应式对象
const info = ref<any>(null)

const sceneList = ref<any[]>([])

// ChatRecord 组件ref
const chatRecordRef = ref<any>(null)
/**
 * 返回
 */
const handleBack = () => {
    chatStore.setIsShowOpeningRemarksPopup(false)
    if (route.query.route) {
        router.push({ path: route.query.route as string })
        return
    }
}
/**
 * 详情
*/
const handleGotoDetail = () => {
    router.push({ name: 'Detail', query: { id: preData.value?.id, route: route.query.route as string } })
}

/**
 * 关闭弹窗
*/
const handleCloseOpeningRemarksPopup = () => {
    showConfirmNamePopup.value = false
    showOpeningRemarksPopup.value = false
    localStorage.setItem('chat-opening-remarks-popup-shown', 'true');
}

/**
 * 点赞
 */
const handleLike = async () => {
    // 更新收藏状态
    if (info.value?.roleInfo) {
        info.value.roleInfo.isFavorite = !info.value?.roleInfo?.isFavorite
    } else {
        info.value.isFavorite = !info.value?.isFavorite
    }

    try {
        await MessageAPI.favoriteRole({
            roleId: info.value?.id,
        })

        detailDB.update(preData.value?.id, info.value)
    } catch (error) {
        console.error('收藏失败:', error)
    }
}
/**
 * 删除历史
*/

const handleDelete = async () => {
    if (isReplying.value) {
        showWarningToast(t('message.pleaseWaitForReply'))
        return
    }
    showDrawer.value = false
    showLoadingToast()
    try {
        const confirmed = await dialog.confirm({
            title: t('history.deleteHistory'),
            message: t('history.deleteCharacterHistory'),
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel'),
            confirmButtonColor: '#667eea'
        })
        if (confirmed) {

            // 删除当前数字人的所有对话消息和本地记录
            await chatStore.deleteCurrentDigitalHumanMessages()
            // 重置对话
            await MessageAPI.resetDialogue({
                roleId: preData.value?.id,
            })
            // 关闭抽屉
            showDrawer.value = false

            // 重置成功后立即清空当前会话消息（内部会自动清除等待状态）
            chatStore.clearCurrentSessionMessages()
            // 重新拉取该角色的聊天记录
            const refreshId = preData.value?.id
            // 重新拉取该角色的聊天记录
            await chatStore.refreshDigitalHuman(refreshId)
            // 显示成功提示
            showSuccessToast(t('message.deleteSuccess'))
        }
    } catch (error) {
        showErrorToast(error as string)
    } finally {
        closeToast()
    }
}


/**
 * 举报
*/
const handleReport = () => {
    getReportType()
    showDrawer.value = false
    showPopup.value = true
}

/**
 * 切换背景图
*/

const handleCheckBg = async () => {
    showDrawer.value = false
    getRoleDetail()
    backgroundStore.getBackgroundList(info.value?.id)
    showBgPopup.value = true
}

const handleShowDrawer = () => {
    showDrawer.value = true
    backgroundStore.getBackgroundList(info.value?.id)
}
/**
 * 获取举报类型
 */
const getReportType = async () => {
    await reportStore.getReportType()
}

/**
 * 关闭弹窗
 */
const handleClosePopup = () => {
    showStorePopup.value = false
    showPopup.value = false
}

/**
 * 获取记录ID
 */
const getRecordId = (id: string) => {
    recordId.value = id
    showPopup.value = true
}

/**
 * 全局翻译
*/
const handleIsAllTranslate = () => {
    showToastPopup.value = true
    isAllTranslate.value = !isAllTranslate.value
    chatStore.setAutoTranslate(isAllTranslate.value)
    if (isAllTranslate.value) {
        logEventSafe('translate_lock_click_on')
    } else {
        logEventSafe('translate_lock_click_off')
    }
    setTimeout(() => {
        showToastPopup.value = false
    }, 1000)
}

/**
 * 处理消息发送事件
 */
const handleMessageSent = () => {
    // if (localStorage.getItem('is_vip_role_card') === '1') {
    // }
}

/**
 * 设置背景图
*/

const handleSetCheckBg = async (id: any, item: any) => {
    showLoadingToast()
    await MessageAPI.setRoleImage({
        imageId: id
    }).then(() => {
        info.value.background = item.url
        preData.value.background = item.url
        detailDB.update(preData.value?.id, info.value)
        showSuccessToast(t('success.switchSuccess'))
        showBgPopup.value = false
    }).finally(() => {
        closeToast()
    })
}
/**
 * 显示思考提示弹窗
 */
const handleThinkingToast = () => {
    // 组件内部会自动处理定时器和隐藏逻辑
    showThinkingToastPopup.value = true
}
/**
 * 显示商店弹窗
*/
const handleShowStorePopup = () => {
    showStorePopup.value = true
}

/**
 * 获取场景列表（本地优先 + 静默更新）
*/
const getSceneList = async () => {
    if (!preData.value?.id) {
        console.warn('⚠️ 角色ID不存在，无法获取场景列表')
        return
    }

    const roleId = preData.value.id

    // 🔧 第一步：立即尝试从缓存加载（不限制过期时间，优先展示）
    const cachedScenes = await getSceneCache(roleId, Infinity)

    if (cachedScenes && cachedScenes.length > 0) {
        sceneList.value = cachedScenes

        setTimeout(() => {
            getShowChangeSceneTip()
        }, 1000)
    }

    // 🔧 第二步：无论缓存是否存在，都在后台静默更新
    try {
        const res = await MessageAPI.getRoleScene({
            roleId: roleId,
        })

        if (res.data && res.data.length > 0) {
            // 比较数据是否有变化
            const hasChanges = !cachedScenes ||
                JSON.stringify(res.data) !== JSON.stringify(cachedScenes)

            if (hasChanges) {
                // 数据有变化，更新界面和缓存
                sceneList.value = res.data
                await saveSceneCache(roleId, res.data)
            } else {
                // 数据没变化，只更新缓存时间戳
                await saveSceneCache(roleId, res.data)
            }

            // 如果之前没有缓存，现在有了新数据，触发提示
            if (!cachedScenes) {
                setTimeout(() => {
                    getShowChangeSceneTip()
                }, 1000)
            }
        }
    } catch (error) {
        console.error('❌ 静默更新场景列表失败:', error)
        // 如果API失败且之前没有缓存，不做任何处理（保持当前状态）
        // 如果有缓存，继续使用缓存（已经在第一步设置了）
        if (!cachedScenes) {
            console.warn('⚠️ 无缓存且API失败，场景列表为空')
        } else {
            console.log(`⚠️ API 失败但已有本地缓存，继续使用 - 角色ID: ${roleId}`)
        }
    }
}

/**
 * 确认名字
 */
const handleConfirmName = (nickname: string) => {
}

/**
 * 获取角色详情
*/
const getRoleDetail = async () => {
    info.value = await detailDB.get(preData.value?.id)
    const res = await MessageAPI.getRoleDetail({
        id: preData.value?.id,
    })

    detailDB.save(preData.value?.id, res.data)
    if (res.data) {
        info.value = res.data
    }
}

/**
 * 获取是否是第一次确认名字
*/
const getIsFirstConfirmName = () => {
    logEventSafe('username_input_popup_show')
    showConfirmNamePopup.value = true
}

const hanldeClose = () => {
    showDrawer.value = false
}


const handleKeyboardShow = () => {
    isKeyboardShow.value = true
    // 键盘弹出时重新计算高度
    setTimeout(() => {
        calculateChatHeight()
    }, 300)
}

const handleKeyboardHide = () => {
    isKeyboardShow.value = false
    // 键盘收起时重新计算高度
    setTimeout(() => {
        calculateChatHeight()
    }, 300)
}

// 判断是否正在回复
const isReplying = computed(
    () => chatStore.isTyping || chatStore.isLoading || chatStore.isInitializing
)

// 发送消息埋点
const sendMessageLogEvent = () => {
    let item = waterfallStore.tabNavs[waterfallStore.activeTab as number]
    switch (item.id) {
        case 2:
            logEventSafe('first_chat_to_hotlist');
            break;
        case 9:
            logEventSafe('first_chat_to_popularlist');
            break;
        case 3:
            logEventSafe('first_chat_to_newlist');
            break;
        case 4:
            logEventSafe('first_chat_to_femalelist');
            break;
        default:
            break;
    }
    switch (item.id) {
        case 2:
            logEventSafe('user_chat_to_hotlist');
            break;
        case 9:
            logEventSafe('user_chat_to_popularlist');
            break;
        case 3:
            logEventSafe('user_chat_to_newlist');
            break;
        case 4:
            logEventSafe('user_chat_to_femalelist');
            break;
        default:
            break;
    }
}

const handleQuickReplyMessage = async (quickReply: any) => {
    showQuickReplyPopup.value = false
    // 先滚动到底部
    await nextTick()
    chatRecordRef.value?.scrollToBottom()
    await chatStore.sendQuickReplyMessage(quickReply)
    await getQuickReply()
}

// 发送消息处理
const handleSendMessage = async (message: string) => {
    // 非订阅用户 + VIP角色卡 + 超过6句对话，跳转VIP页面
    if (info.value?.isVip === 1) {
        await roleProfileDB.incrementLocalChatCount(info.value?.id)
    }
    // 获取角色本地聊天次数
    const chatCount = await roleProfileDB.getLocalChatCount(info.value?.id)
    if (info.value?.isVip === 1 && ![4, 5].includes(userStore.userInfo.role) && chatCount > 6) {
        router.push({ name: 'Vip', query: { type: 'u' } })
        return
    }
    // 用户第一次发送消息
    if (!localStorage.getItem('user_has_chatted_before')) {
        sendMessageLogEvent();
        localStorage.setItem('user_has_chatted_before', 'true')
    }

    try {
        if (route.query.isFree === 'true') {
            logEventSafe('free_user_send_message')
        }
        // 先滚动到底部
        await nextTick()
        chatRecordRef.value?.scrollToBottom()

        await chatStore.sendMessage(message)

        // 触发消息发送事件，用于评分弹窗计数
        handleMessageSent()

        if (getMessageCount() === 5) {
            getIsFirstConfirmName()
        }
        if (localStorage.getItem('select_reply_popup_click_send') === '1') {
            logEventSafe('send_success');
            localStorage.removeItem('select_reply_popup_click_send');
        }
    } catch (error) {
        if (localStorage.getItem('select_reply_popup_click_send') === '1') {
            logEventSafe('send_failed');
            localStorage.removeItem('select_reply_popup_click_send');
        }
        console.error('发送消息失败:', error)
    }
}

// 切换场景
const handleSwitchScene = async (item: any) => {
    if (isReplying.value) {
        showErrorToast(t('message.pleaseWaitForReplyCurrent'))
        return
    }
    if (![4, 5].includes(userStore.userInfo.role)) {
        router.push({ name: 'Vip', query: { type: 'u' } })
        return
    }

    try {
        showLoadingToast(t('message.switchingScene'))
        // 调用切换场景接口
        const res = await MessageAPI.switchRoleScene({
            sceneId: item.id,
            roleId: item?.roleId,
        })

        // 切换成功后，重新加载聊天记录
        if (res && chatStore.currentDigitalHumanId) {
            // 删除当前数字人的所有对话消息和本地记录
            await chatStore.deleteCurrentDigitalHumanMessages()
            // 使用 refreshDigitalHuman 方法刷新数字人数据和聊天记录
            await chatStore.refreshDigitalHuman(chatStore.currentDigitalHumanId)

            // 🔧 清除旧的场景缓存，强制从 API 获取最新数据
            if (preData.value?.id) {
                await deleteSceneCache(preData.value.id)
            }
            await getSceneList()

            // 关闭弹窗
            showSwitchModelPopup.value = false

            // 滚动到底部
            await nextTick()
            chatRecordRef.value?.scrollToBottom()

            showSuccessToast(t('message.switchSceneSuccess'))
        }
    } catch (error) {
        console.error('切换场景失败:', error)
        showErrorToast(t('message.switchSceneFailed'))
    }
}

// 滑动清屏处理
const handleTouchStart = (e: TouchEvent) => {
    // 只处理单指触摸
    if (e.touches.length !== 1) return

    const touch = e.touches[0]
    touchStartX.value = touch.clientX
    touchStartY.value = touch.clientY
    touchStartTime.value = Date.now()
    isSwipeActive.value = true
}

const handleTouchMove = (e: TouchEvent) => {
    if (!isSwipeActive.value || e.touches.length !== 1) return

    const touch = e.touches[0]
    const deltaX = touch.clientX - touchStartX.value
    const deltaY = touch.clientY - touchStartY.value

    // 如果垂直滚动距离大于水平滑动距离，说明是垂直滚动，取消清屏手势
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
        isSwipeActive.value = false
    }
}

const handleTouchEnd = (e: TouchEvent) => {
    if (!isSwipeActive.value) return

    const touch = e.changedTouches[0]
    const deltaX = touch.clientX - touchStartX.value
    const deltaY = touch.clientY - touchStartY.value
    const deltaTime = Date.now() - touchStartTime.value

    // 检测水平滑动
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) * 2
    const screenWidth = window.innerWidth

    // 从左到右滑动：清屏
    if (deltaX > 100 && isHorizontalSwipe && deltaTime < 500 && touchStartX.value < screenWidth * 0.3) {
        if (!isCleared.value) {
            // 保存当前消息
            const currentSession = chatStore.currentSession
            if (currentSession && currentSession.messages) {
                clearedMessages.value = [...currentSession.messages]
            }
            // 播放清屏动画
            isClearing.value = true
            setTimeout(() => {
                chatStore.clearCurrentSessionMessages()
                isCleared.value = true
                isClearing.value = false
            }, 300) // 动画时间
        }
    }
    // 从右到左滑动：还原
    else if (deltaX < -100 && isHorizontalSwipe && deltaTime < 500 && touchStartX.value > screenWidth * 0.7) {
        if (isCleared.value && clearedMessages.value.length > 0) {
            // 先还原消息
            const currentSession = chatStore.currentSession
            if (currentSession) {
                currentSession.messages = [...clearedMessages.value]
                currentSession.updatedAt = Date.now()
                chatStore.saveToStorage()
            }
            isCleared.value = false
            // 播放还原动画
            isRestoring.value = true
            setTimeout(() => {
                isRestoring.value = false
                clearedMessages.value = []
            }, 300) // 动画时间
        }
    }

    isSwipeActive.value = false
}


// 提示用户切换场景
const getShowChangeSceneTip = () => {
    const hasShownTip = localStorage.getItem('chat-change-scene-tip-shown')
    if (!hasShownTip) {
        showChangeSceneTip.value = true
        setTimeout(() => {
            showChangeSceneTip.value = false
            localStorage.setItem('chat-change-scene-tip-shown', 'true')
        }, 2000)
    }
}

const handleShowOpeningRemarksPopup = () => {
    if (currentMessages.value.length <= 1) {
        logEventSafe(`select_reply_popup_show${userStore.userInfo?.userId}`);
        showOpeningRemarksPopup.value = true
    }
}

/**
 * 重新生成AI消息（原地重新生成）
 */
const handleShowReloadMessagePopup = async (message?: any) => {
    if (!message) return

    try {

        // 调用store方法重新生成
        // store会删除旧消息，然后WebSocket会创建新消息
        await chatStore.regenerateMessage(
            Number(info.value?.id),
            message.msgId || message.id,
            message.id
        )
        // 先滚动到底部
        await nextTick()
        chatRecordRef.value?.scrollToBottom()
    } catch (error: any) {
        console.error('重新生成消息失败:', error)
        showErrorToast(error.message || '重新生成失败，请重试')
    }
}

const getModelList = async () => {
    const res = await MessageAPI.modelList({})
    modelList.value = res.data

    localStorage.setItem('modelIndex', String(modelList.value.find((item: any) => item.isChecked === true)?.id))
}
const getQuickReply = async () => {
    const res = await MessageAPI.getQuickReply({})
    if (res.code === 200) {
        quickReplyList.value = res.data
    }

}

const calculateChatHeightThrottle = useThrottleFn(calculateChatHeight, 16)


onMounted(async () => {
    try {

        /**
         * UI立即初始化
         */
        isAllTranslate.value = chatStore.autoTranslate

        calculateChatHeight()

        setTimeout(() => {
            isBackdropReady.value = true
        }, 100)

        /**
         * 解析预数据
         */
        if (route.query.preData) {
            preData.value = JSON.parse(
                decodeURIComponent(route.query.preData as string)
            )
        }

        /**
         * 本地缓存优先
         */
        const cacheData = await detailDB.get(preData.value?.id)

        if (cacheData) {
            info.value = cacheData

            preData.value.background =
                cacheData?.background
        }

        /**
         * =====================
         * 首屏核心接口
         * =====================
         */

        await Promise.all([
            getRoleDetail(),
            loadDefaultBackground(info.value?.sex)
        ])

        /**
         * =====================
         * 后台接口
         * 不阻塞页面
         * =====================
         */

        Promise.allSettled([
            getSceneList(),

            getModelList(),

            backgroundStore.getBackgroundList(
                preData.value?.id
            ),

            getReportType(),

            getQuickReply()
        ])

        /**
         * 监听
         */

        window.addEventListener(
            'resize',
            calculateChatHeightThrottle,
            { passive: true }
        )

        window.visualViewport?.addEventListener(
            'resize',
            calculateChatHeightThrottle,
            { passive: true }
        )

    } catch (e) {
        console.error(e)
    }
})

// 🔧 组件卸载时清理事件监听器
onUnmounted(() => {
    backgroundStore.backgroundList = []
    window.removeEventListener('resize', calculateChatHeight)
    if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', calculateChatHeight)
    }
})


</script>

<style scoped lang="scss">
.rigth-popup {
    .van-popup {
        background-color: #01031B;
        border-radius: 10px;
    }
}

.van-popup {
    border-radius: 10px;
}

.mask-transparent-top {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
    pointer-events: none;
    /* 不阻止鼠标事件，事件会穿透 */
}

.mask-transparent-bottom {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);

    &.backdrop-ready {
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        mask-image: linear-gradient(to bottom,
                transparent 0%,
                transparent 10%,
                black 50%,
                black 100%);
        -webkit-mask-image: linear-gradient(to bottom,
                transparent 0%,
                transparent 10%,
                black 50%,
                black 100%);
    }


}

/* 清屏动画：消息内容淡出 */
.message-clearing {
    animation: messageFadeOut 0.3s ease-out forwards;
}

/* 还原动画：消息内容淡入 */
.message-restoring {
    animation: messageFadeIn 0.3s ease-out forwards;
}

@keyframes messageFadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes messageFadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

:deep(.custom-toast) {
    width: 147px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 7px;
    color: #01031B;
}
</style>
